export class commonData {
  pageSize = 50;
  currentPage = 1;
}

export class HardcodedValue {
  ghgAvoidanceSubModuleID = 7;
  ghgAvoidanceModuleId = 2;
  ghgAvoidanceCategoryId = 1;
}

export class GhgEmissionScopeHardCodedValue {
  scope3Cat1: number = 13;
  scope3Cat2: number = 14;
  scope3Cat3: number = 15;
  scope3Cat4: number = 16;
  scope3Cat5: number = 17;
  scope3Cat6: number = 18;
  scope3Cat7: number = 19;
  scope3Cat8: number = 20;
  scope3Cat9: number = 21;
  scope3Cat10: number = 22;
  scope3Cat11: number = 23;
  scope3Cat12: number = 24;
  scope3Cat13: number = 25;
  scope3Cat14: number = 26;
  scope3Cat15: number = 27;
}

export class ghgEmissionAvoidanceSaveSubmitButtonId {
  draftButtonId = 1;
  submitButtonId = 2;
  approvedButtonId = 3;
  rejectButtonId = 4;
}

export class ghgEmissionAvoidanceActionType {
  addAction = 1;
  editAction = 2;
  deleteAction = 3;
}

export class scopeList {
  scopeList = [
    { name: 'Scope 1', id: 1 },
    { name: 'Scope 2', id: 2 },
    { name: 'Scope 3', id: 3 },
  ];
}

export class materialityAssesmentTopicList {
  predefined = 1;
  sasb = 2;
  peerAnalysis = 3;
  selfIdentified = 4;
}

export class benchmarkStatus {
  pending = 1;
  approved = 2;
  benchmark = 3;
}

export class policyList {
  current = 1;
  obsolete = 2;
}

export class reportingPeriodDuration {
  Previous = 'Previous';
  Current = 'Current';
  CurrentAndNext = 'CurrentAndNext';
  All = 'All';
}

export class brsrCertificationType {
  Other = 'Other';
}

export class monthsName {
  months: any = {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
  };
}

export class quarterOrder {
  quarterOrder: any = {
    'Jan-Mar': 1,
    'Apr-Jun': 2,
    'Jul-Sep': 3,
    'Oct-Dec': 4,
  };
}

export class CurrencyMapData {
  static currencySymbolMap: { [code: string]: string } = {
    INR: '₹',
    USD: '$',
    EUR: '€',
    GBP: '£',
    JPY: '¥',
    AUD: 'A$',
    CAD: 'C$',
    CNY: '¥',
  };
}

export class UnitTagIds {
  stackDimension = 27;
  fuelGasVelocity = 28;
  totalGasQuantity = 29;
  airEmission = 30;
}

export class ConstantMessage {
  finalized = 'Data finalized successfully';
  submitted = 'Data submitted successfully';
  saved = 'Data saved successfully';
  updated = 'Data updated successfully';
  dataDeleted = 'Data deleted successfully';
  rowDeleted = 'Row deleted successfully';
  approved = 'Data approved successfully';
  rejected = 'Data rejected successfully';
  addRowBeforeDelete =
    'When you are deleting the first row make sure you add an empty row';
}

export class UploadDocumentClassId {
  InvoicesOrContracts = 1;
  ConsumptionLogs = 2;
  SupplierCertificates = 3;
  DeliveryChallansBills = 4;
  LaboratoryAnalysisCertificates = 5;
  DPCSEvidence = 6;
  STPC_Stakeholders = 8;
  EmployeeSatisfactionRetention_Survey_Feedback = 9;
  CHSFinesPenalties = 10;
  CHSEvidencesDocuments = 11;
  WasteManagementCertificate = 12;
  UserManagementProfile = 13;
  EnergyManagementDocument = 14;
  EmpDetailsPersonalInformationDoc = 16;
  CsrSigature = 17;
  BusinessEthicsAntiCorruptionRisk = 18;
  BusinessEthicsGuidelines = 19;
  BusinessEthicsInternalRecords = 20;
  BusinessEthicsGrievanceRecords = 21;
  OrgSetupCorpLogo = 22;
  OrgSetupContactPerson = 23;
  RegionalOfficeContactPerson = 24;
  SiteOfficeContactPerson = 25;
  AvoidanceRemovalStrategyDoc = 26;
  Scope1 = 27;
  Scope2 = 28;
  Scope3 = 29;
  BiodiversityRisksandComplianceDoc = 30;
  MinimumWagesCompliance = 31;
  CompensationBenefitsCompliance = 32;
  TrainingAndDevelopmentAttendanceForm = 33;
  TrainingAndDevelopmentFeedbackForm = 34;
  TrainingAndDevelopmentCalendar = 35;
  TrainingAndDevelopmentDetailsDoc = 36;
  SupplierPhoto = 37;
  SupplierFactoryLicense = 38;
  SupplierFactoryLicenseCertificates = 39;
  SupplierFactoryLicenseDeclarations = 40;
  SupplierFactoryAuditInternal = 41;
  SupplierFactoryAuditThirdParty = 42;
  PolicyDocument = 43;
  MentalHealth = 44;
  PhysicalHealth = 45;
  SupplierQuestionaire = 46;
  Rootcauseanalysis = 47;
  RiskAssessmentHazard = 48;
  ErgonomicsAssessments = 49;
  EmergencyPreparedness = 50;
}
